// extracted by mini-css-extract-plugin
module.exports = {"root":"InquiryWizardSection_root__3Xpn4"};